import { NgModule } from '@angular/core';
import { RoutingService } from './services/routing.service';
import { SecurityService } from './services/security.service';
import { SecurityHelperService } from './services/security-helper.service';

@NgModule({
  providers: [
    RoutingService,
    SecurityService,
    SecurityHelperService
  ],
})
export class SecurityModule { }
